import {
  SR_API_ACTION_GET_TOUR_LIST,
} from 'api/actionTypes';

export default async function getList({ state, apiClient }, params = {}) {
  const { reloadTours } = params;
  if (!reloadTours) {
    const tours = state.get(['tours']);
    if (tours && tours.length) {
      return tours;
    }
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_TOUR_LIST,
    state: state,
    queryId: params.queryId,
    onSuccess(tours) {
      state.set(['tours'], tours);
    },
  });
}
